import { IcoMinusSmall16, IcoPlusSmall16 } from '@onefootprint/icons';

type CategoryToggleProps = {
  categoryName: string;
  onClick: () => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  isActive: boolean;
  tabIndex?: number;
};

const CategoryToggle = ({ categoryName, onClick, onKeyDown, isActive, tabIndex = 0 }: CategoryToggleProps) => {
  return (
    <button
      type="button"
      className="flex items-center gap-2 p-1 transition-all rounded duration-50 group hover:bg-hover"
      onClick={onClick}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex}
      aria-expanded={isActive}
      aria-label={`${categoryName} toggle`}
    >
      {isActive ? <IcoMinusSmall16 color="secondary" /> : <IcoPlusSmall16 color="secondary" />}
      <div className="text-label-2 text-secondary">{categoryName}</div>
    </button>
  );
};

export default CategoryToggle;
